/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export const FormErrorExamples = {
  formControlName: `
    <az-form [formGroup]="myGroup">
      <form-control [name]=" 'firstName' "></form-control>
    </az-form>

    In your class:

    constructor( private _fb: AzoraFormBuilder){}

    this.myGroup = this._fb.group({
       firstName: {
            component: 'input',
            props: {
                value: 'YourName'
            },
            schema: Joi.string().required()
        }
    });`,


  formGroupName: `
    <div [formGroup]="myGroup">
       <div formGroupName="person">
          <input formControlName="firstName">
       </div>
    </div>

    In your class:

    this.myGroup = new FormGroup({
       person: new FormGroup({ firstName: new FormControl() })
    });`,

  formArrayName: `
    <div [formGroup]="myGroup">
      <div formArrayName="cities">
        <div *ngFor="let city of cityArray.controls; index as i">
          <input [formControlName]="i">
        </div>
      </div>
    </div>

    In your class:

    this.cityArray = new FormArray([new FormControl('SF')]);
    this.myGroup = new FormGroup({
      cities: this.cityArray
    });`,

  ngModelGroup: `
    <form>
       <div ngModelGroup="person">
          <input [(ngModel)]="person.name" name="firstName">
       </div>
    </form>`,

  ngModelWithFormGroup: `
    <div [formGroup]="myGroup">
       <input formControlName="firstName">
       <input [(ngModel)]="showMoreControls" [ngModelOptions]="{standalone: true}">
    </div>
  `,

  missingName: `
    <az-form [formGroup]="myGroup">
      <form-control [name]=" 'firstName' "></form-control>
    </az-form>

    In your class:

    constructor( private _fb: AzoraFormBuilder){}

    this.myGroup = this._fb.group({
        firstName: {
            component: 'input',
            props: {
                value: 'YourName'
            },
            schema: Joi.string().required()
        }
    });
  `
};
